module.exports = __webpack_public_path__ + "img/PB级-分布式存储能⼒.9d6cd063.png";